import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import {ConfirmationPageElement} from "./components/ConfirmationPage";
import 'antd/dist/antd.css';


function App() {
  return <React.Fragment>
      <Router>
        <Switch>
          <Route path="/fc/confirm">
              <ConfirmationPageElement/>
          </Route>
        </Switch>
      </Router>
  </React.Fragment>
}

export default App;
